function ItemResults({ item, openJob }) {
    // if (typeof _zbo === "undefined") {
    //     var _zbo = {
    //         register: () => {
    //             console.log("TEST")
    //         },
    //     }
    // }

    function openDetail(e) {
        e.preventDefault()
        openJob(item)
    }

    function postulerClickTags(e) {
        window._zbo.register("lead")
        // if (typeof window.tag !== "undefined" && item.categorisation_pour_tag) {
        if (typeof window.tC !== "undefined" && item.categorisation_pour_tag) {
            // window.tag.click.send({ elem: e.target, name: item.categorisation_pour_tag + "_JE_POSTULE", type: "navigation" })
            window.tC.event.AtClick(e.target, { evt_action_libelle: item.categorisation_pour_tag + "_JE_POSTULE" })
        }
    }

    let itemClass = item.isSiegeSocial ? "job-result-card siege-social-card" : "job-result-card reseau-agence-card"

    return (
        <div className="c-article-item__img-wrapper">
            <div className={itemClass}>
                <div className="list-tags">
                    <span className="tag">{item.contract_type_abbreviation}</span>
                    {item.isSiegeSocial ? <span className="tag tag-green">Siège social</span> : <span className="tag tag-red">Réseau d'agences</span>}
                </div>
                <h1>{item.title}</h1>
                {/* <h4>{item.last_publication_date.format("LLL")}</h4> */}
                <p>{item.localisation}</p>
                <div>
                    <a href={`./${item.id}`} onClick={openDetail} className="c-button c-button--white">
                        Voir les détails
                    </a>
                    <a href={item.apply_web_url} target="_blank" onClick={postulerClickTags} className="c-button c-button--primary">
                        Postulez
                    </a>
                    {/* <a href={item.apply_web_url} target="_blank" onClick="_zbo.register('lead');" className="c-button c-button--primary">
                        Postulez
                    </a> */}
                </div>
            </div>
        </div>
    )
}

export default ItemResults
